import graphql__14da52806d218685808f from "./__generated__/CommentFormManagerQuery.graphql.js";import { graphql } from "react-relay";
import AppQueryRenderer from "../AppQueryRenderer";

import ModalLoader from "../Modals/ModalLoader";
import CommentForm from "./CommentForm";

const CommentFormManager = props => {
  const { commentableId } = props;

  return (
    <AppQueryRenderer
      query={CommentFormManagerQuery}
      variables={{ commentableId }}
      additionalProps={props}
      loader={<ModalLoader />}
      component={CommentForm}
    />
  );
};

const CommentFormManagerQuery = graphql__14da52806d218685808f;

export default CommentFormManager;
